export default __webpack_public_path__ + "static/media/logo-h-bold.3ea3f1f0.png";